import styled from 'styled-components';

const Wrapper = styled.div`
  width: 92px;
  height: 52px;
  background-color: rgba(100, 100, 100, 0.4);
  pointer-events: none;
  position: absolute;
  left: 37px;
  border-radius: 6px;
  text-align: center;
  margin-top: -3px;

  video {
    position: absolute;
    left: 0px;
    border-radius: 6px;
  }

  .spinner-obj {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
    opacity: 0.5;
    margin-top: 2px;
  }
  
  .spinner-obj div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    margin-top: 5px;
    border: 5px solid #ddd;
    border-radius: 50%;
    animation: spinner-obj 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #ddd transparent transparent transparent;
  }

  .spinner-obj div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .spinner-obj div:nth-child(2) {
    animation-delay: -0.3s;
  }
  
  .spinner-obj div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes spinner-obj {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default { Wrapper };
